// ── SVG icons ─────────────────────────────────────────────────────────────────

const IconFolder = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2.5 5.5A1.5 1.5 0 0 1 4 4h3.5l2 2H16a1.5 1.5 0 0 1 1.5 1.5v7A1.5 1.5 0 0 1 16 16H4a1.5 1.5 0 0 1-1.5-1.5v-9z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
)

const IconImage = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect x="2.5" y="4" width="15" height="12" rx="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="7" cy="8.5" r="1.5" fill="currentColor" opacity="0.45"/>
    <path d="M2.5 14l4.5-4.5 3 3 2-2 6 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
)

const IconPlusCircle = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 7v6M7 10h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

const IconSearch = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M13 13l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

const IconBolt = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M11.5 2.5L4 11h6l-1.5 6.5L18 9h-6l1.5-6.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
)

const IconLayers = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10 2.5L17.5 7 10 11.5 2.5 7 10 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    <path d="M2.5 11L10 15.5 17.5 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

// ── Data ──────────────────────────────────────────────────────────────────────

const menuFeatures = [
  { Icon: IconFolder,    title: 'Categorias organizadas',   desc: 'Crie categorias como Entradas, Pratos, Bebidas e Sobremesas. Reordene com facilidade.' },
  { Icon: IconImage,     title: 'Fotos dos pratos',         desc: 'Adicione múltiplas fotos por item. Imagens que fazem o cliente querer pedir.' },
  { Icon: IconPlusCircle,title: 'Complementos e adicionais',desc: 'Configure add-ons como "ponto da carne", "sem cebola" ou "queijo extra".' },
  { Icon: IconSearch,    title: 'Busca no cardápio',        desc: 'Clientes encontram o que querem em segundos com busca em tempo real.' },
  { Icon: IconBolt,      title: 'Atualização instantânea',  desc: 'Mudou o preço? Acabou o prato? Edite e o cardápio online atualiza na hora.' },
  { Icon: IconLayers,    title: 'Múltiplos cardápios',      desc: 'Crie cardápios separados para almoço, jantar, happy hour ou fins de semana.' },
]

// ── Section ───────────────────────────────────────────────────────────────────

export default function MenuSection() {
  return (
    <section className="px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24 scroll-mt-24" style={{ background: '#FAFAF8' }} id="cardapio">
      <div className="max-w-[1140px] mx-auto">
        <div className="text-[11px] font-bold uppercase tracking-[2px] text-neutral-400 mb-3">
          Cardápio Digital
        </div>
        <h2 className="text-[30px] sm:text-[38px] lg:text-[50px] font-black tracking-tight leading-[1.08] mb-4">
          Monte seu cardápio<br />do zero em minutos.
        </h2>
        <p className="text-[15px] lg:text-[16px] text-neutral-500 leading-[1.75] max-w-[500px]">
          Crie categorias, adicione pratos com fotos, preços e complementos. Tudo atualiza em tempo real no site do seu restaurante.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-10 lg:mt-14">
          {menuFeatures.map((feat) => (
            <div
              key={feat.title}
              className="bg-white border border-neutral-150 rounded-2xl p-5 hover:border-neutral-300 transition-colors"
              style={{ borderColor: '#ebebeb' }}
            >
              <div className="w-8 h-8 rounded-lg bg-neutral-100 flex items-center justify-center text-neutral-600 mb-4">
                <feat.Icon />
              </div>
              <h3 className="text-[14px] font-bold mb-1.5 tracking-tight">{feat.title}</h3>
              <p className="text-[13px] text-neutral-500 leading-[1.6]">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
